import {
  Box,
  Typography,
  Grid,
  Card,
  CardActionArea
} from '@mui/material';
import {
  Assessment as AssessmentIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const REPORTS = [
  {
    id: 'agent-daily',
    name: 'Reporte Diario de Agentes',
    description: 'Estadísticas detalladas de agentes por día',
    icon: AssessmentIcon,
    path: '/reports/agent-daily'
  },
  // Aquí se pueden agregar más reportes en el futuro
  // {
  //   id: 'skill-performance',
  //   name: 'Rendimiento por Skill',
  //   description: 'Métricas de performance por skill',
  //   icon: BarChartIcon,
  //   path: '/reports/skill-performance'
  // },
];

const ReportsPage = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom fontWeight={600}>
        Reportes y Estadísticas
      </Typography>
      <Typography variant="body1" color="text.secondary" gutterBottom>
        Selecciona un reporte para visualizar
      </Typography>

      <Grid container spacing={3} sx={{ mt: 2 }}>
        {REPORTS.map((report) => {
          const Icon = report.icon;
          return (
            <Grid item xs={12} sm={6} md={4} key={report.id}>
              <Card>
                <CardActionArea onClick={() => navigate(report.path)} sx={{ p: 3 }}>
                  <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
                    <Icon sx={{ fontSize: 60, color: 'primary.main' }} />
                    <Typography variant="h6" align="center">
                      {report.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" align="center">
                      {report.description}
                    </Typography>
                  </Box>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default ReportsPage;
